/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import commaSeparetedValue from './commaSeparetedValue'
import warrantyLabel from '../config/warranty'

export const getProductValues = (product, pageType) => {
  let title = ''
  let hasVehicle = false
  let vehicleInfo = ''
  let hasPartOrSkuNumber = false
  let partNumber = ''
  let skuNumber = ''
  let quantity = 0
  let hasTotalUnitPrice = false
  let totalUnitPrice = 0
  let listPrice = 0
  let regularPrice = 0
  let hasTotalCore = false
  let totalCore = 0
  let hasQuantity = false
  let corePrice = 0
  let hasTotalWarranty = false
  let warrantyLabelValue = ''
  let totalWarranty = 0
  let hasWarrantyPrice = false
  let warrantyPrice = ''
  let hasTotalAmount = false
  let totalAmount = 0
  let hasProductProtection = false
  let productProtectionLabel = ''
  let productProtectionPrice = 0
  let totalProductProtection = 0

  const {
    title: productTitle = '',
    vehicle = {},
    itemTotalUnitPrice: productTotalUnitPrice,
    itemTotalCore: productTotalCore = '',
    corePrice: productCorePrice = '',
    itemTotalWarranty: productTotalWarranty = '',
    warrantyCode: productWarrantyCode = '',
    itemTotalAmount: productItemTotalAmount,
    productProtection,
    productProtectionPlans,
  } = product

  if (typeof productProtection !== 'undefined' && productProtection) {
    if (productProtection?.applied) {
      const eppPlanId = productProtection?.planId
      hasProductProtection = productProtection?.applied
      const selectedEpp = productProtectionPlans?.find(epp => epp.code === eppPlanId)
      productProtectionPrice = selectedEpp?.price
      productProtectionLabel = `${selectedEpp?.type} Product Protection Plan`
      totalProductProtection = (parseFloat(productProtectionPrice) * product?.quantity).toFixed(2)
    } else {
      hasProductProtection = true
      productProtectionPrice = parseFloat(productProtection?.price / product?.qty).toFixed(2)
      productProtectionLabel = `${productProtection?.type} Product Protection Plan`
      totalProductProtection = parseFloat(productProtection?.price).toFixed(2)
    }
  }

  const {
    year = '',
    make = '',
    model = '',
    submodel = '',
    engine = '',
  } = vehicle

  title = productTitle || ''
  hasVehicle = Boolean(year) || false
  vehicleInfo = `${year} ${make} ${model} ${submodel} ${engine}` || ''
  hasTotalUnitPrice =
    Boolean(
      productTotalUnitPrice &&
        productTotalUnitPrice !== '0.00' &&
        productTotalUnitPrice !== '0',
    ) || false
  totalUnitPrice = commaSeparetedValue(productTotalUnitPrice || 0)
  hasTotalCore =
    Boolean(
      productTotalCore &&
        productTotalCore !== '0.00' &&
        productTotalCore !== '0',
    ) || false
  totalCore = commaSeparetedValue(productTotalCore || 0)
  corePrice = commaSeparetedValue(productCorePrice || 0)
  hasTotalWarranty =
    Boolean(
      productTotalWarranty &&
        productTotalWarranty !== '0.00' &&
        productTotalWarranty !== '0' &&
        totalProductProtection <= 0 &&
        warrantyLabel[productWarrantyCode],
    ) || false
  warrantyLabelValue = warrantyLabel[productWarrantyCode] || ''
  totalWarranty = productTotalWarranty || ''
  hasTotalAmount =
    Boolean(
      productItemTotalAmount &&
        productItemTotalAmount !== '0.00' &&
        productItemTotalAmount !== '0',
    ) || false
  totalAmount = productItemTotalAmount || ''

  if (pageType === 'checkoutConfirmation') {
    const {
      skuNumber: productSkuNumber = '',
      quantity: productQuantity = 0,
      warrantyPrice: productWarrantyPrice = 0,
      listPrice: productListPrice = 0,
    } = product

    hasPartOrSkuNumber = Boolean(productSkuNumber) || false
    skuNumber = productSkuNumber || ''
    quantity = productQuantity || ''
    hasQuantity = Boolean(productQuantity > 1) || false
    hasWarrantyPrice = Boolean(productWarrantyPrice)
    warrantyPrice = productWarrantyPrice || ''
    listPrice = commaSeparetedValue(productListPrice || 0)
  } else {
    const {
      partNumber: productPartNumber = '',
      qty: productQty = 0,
      cpp: productCpp = 0,
      regularPrice: productRegularPrice = 0,
    } = product

    hasPartOrSkuNumber = Boolean(productPartNumber) || false
    partNumber = productPartNumber || ''
    quantity = productQty || ''
    hasQuantity = Boolean(productQty > 1) || false
    hasWarrantyPrice = Boolean(productCpp)
    warrantyPrice = productCpp || ''
    regularPrice = commaSeparetedValue(productRegularPrice || 0)
  }

  return {
    title,
    hasVehicle,
    vehicleInfo,
    hasPartOrSkuNumber,
    partNumber,
    skuNumber,
    quantity,
    hasTotalUnitPrice,
    totalUnitPrice,
    regularPrice,
    listPrice,
    hasTotalCore,
    totalCore,
    hasQuantity,
    corePrice,
    hasTotalWarranty,
    warrantyLabelValue,
    totalWarranty,
    hasWarrantyPrice,
    warrantyPrice,
    hasTotalAmount,
    totalAmount,
    hasProductProtection,
    productProtectionLabel,
    productProtectionPrice,
    totalProductProtection,
  }
}

export const getOrderValues = (order, pageType) => {
  let shippingName = ''
  let billingName = ''

  let shippingStreetAddress = ''
  let shippingSuburbAddress = ''
  let billingStreetAddress = ''
  let billingSuburbAddress = ''

  let shippingCity = ''
  let billingCity = ''

  let shippingState = ''
  let billingState = ''

  let shippingPostcode = ''
  let billingPostcode = ''

  let shippingCountry = ''
  let billingCountry = ''

  let shippingTelephone = ''
  let billingTelephone = ''

  let shippingMethod = ''
  let merchantId = ''
  let date = ''
  let total = 0
  let paymentMethod = ''
  let subtotal = 0
  let totalShipping = 0
  let totalHandling = 0
  let totalTax = 0
  let shippingProtectionAmount = 0
  let totalWarranty = 0
  let totalProductProtection = 0
  let totalCorePrice = 0
  const arrShipMethod = []
  let itemShipMethod = []

  const {
    merchantOrderId = '',
    orderDate = '',
    orderSummary = {},
    items: orderItems = [],
    shippingProtection = {},
  } = order

  orderItems.map(value => {
    let shippingMethod = value?.shippingMethod || null;

    if (!shippingMethod &&
        value?.shippingMethodCode?.toLowerCase() === 'standard' &&
        value?.packagingState?.toLowerCase() === 'unfolded'
      ) {
      shippingMethod = 'Ground_unfolded';
    }

    arrShipMethod.push(shippingMethod);
    return shippingMethod;
  }).filter(el => el !== null);

  if (arrShipMethod && arrShipMethod.length > 0) {
    const shipId = [...new Set(arrShipMethod.filter(el => el !== null))]
    if (shipId && shipId.length) {
      if (shipId.length > 1) {
        itemShipMethod.push('GROUND')
      } else {
        itemShipMethod = shipId.map(value => value)
      }
    }
  }

  merchantId = merchantOrderId || ''
  date = orderDate || ''
  const items = orderItems || []

  const {
    total: orderTotal = 0,
    subtotal: orderSubTotal = 0,
    totalShipping: orderTotalShipping,
    totalHandling: orderTotalHandling,
    totalTax: orderTotalTax,
    totalWarranty: orderTotalWarranty,
    totalProductProtection: orderTotalProductProtection,
    totalCorePrice: orderTotalCorePrice,
  } = orderSummary

  total = commaSeparetedValue(orderTotal || 0)
  subtotal = commaSeparetedValue(orderSubTotal || 0)
  totalShipping = commaSeparetedValue(orderTotalShipping || 0)
  totalHandling = commaSeparetedValue(orderTotalHandling || 0)
  totalTax = commaSeparetedValue(orderTotalTax || 0)
  totalWarranty = commaSeparetedValue(orderTotalWarranty || 0)
  totalProductProtection = commaSeparetedValue(orderTotalProductProtection || 0)
  totalCorePrice = commaSeparetedValue(orderTotalCorePrice || 0)
  shippingProtectionAmount = commaSeparetedValue(shippingProtection?.amount || 0)

  if (pageType === 'checkoutConfirmation') {
    const {
      shipping: { address: shippingAddress = {} },
      billing: { address: billingAddress = {} },
      payment = {},
    } = order

    const {
      deliveryName: sName = '',
      deliveryStreetAddress: sStreetAddress = '',
      deliveryCity: sCity = '',
      deliveryState: sState = '',
      deliveryPostcode: sPostcode = '',
      deliveryCountry: sCountry = '',
      deliveryTelephone: sTelephone = '',
      shippingMethod: sShippingMethod = '',
      deliverySuburbAddress: sSuburbAddress = '',
    } = shippingAddress

    const {
      customerFirstName: bFirstName = '',
      customerLastName: bLastName = '',
      customerStreetAddress: bStreetAddress = '',
      customerSuburbAddress: bSuburbAddress = '',
      customerCity: bCity = '',
      customerState: bState = '',
      customerPostcode: bPostcode = '',
      customerCountry: bCountry = '',
      customerTelephone: bTelephone = '',
    } = billingAddress

    const { paymentMethod: bPaymentMethod = '' } = payment || {}

    const bName = `${bFirstName} ${bLastName}`

    shippingName = sName || ''
    billingName = bName || ''

    shippingStreetAddress = sStreetAddress || ''
    shippingSuburbAddress = sSuburbAddress || ''
    billingStreetAddress = bStreetAddress || ''
    billingSuburbAddress = bSuburbAddress || ''

    shippingCity = sCity || ''
    billingCity = bCity || ''

    shippingState = sState || ''
    billingState = bState || ''

    shippingPostcode = sPostcode || ''
    billingPostcode = bPostcode || ''

    shippingCountry = sCountry || ''
    billingCountry = bCountry || ''

    shippingTelephone = sTelephone || ''
    billingTelephone = bTelephone || ''

    shippingMethod = sShippingMethod || ''
    paymentMethod = bPaymentMethod || ''
  } else {
    const { shipping = {}, billing = {} } = order

    const {
      name: sName = '',
      address: shippingAddress = {},
      telephone: sTelephone = '',
      shippingMethod: sShippingMethod,
    } = shipping

    const {
      name: bName = '',
      address: billingAddress = {},
      telephone: bTelephone = '',
      paymentMethod: bPaymentMethod,
    } = billing

    const {
      streetAddress: sStreetAddress = '',
      city: sCity = '',
      state: sState = '',
      postcode: sPostcode = '',
      country: sCountry,
      suburbAddress: sSuburbAddress = '',
    } = shippingAddress

    const {
      streetAddress: bStreetAddress = '',
      city: bCity = '',
      state: bState = '',
      postcode: bPostcode = '',
      country: bCountry,
      suburbAddress: bSuburbAddress = '',
    } = billingAddress

    shippingName = sName || ''
    billingName = bName || ''

    shippingStreetAddress = sStreetAddress || ''
    shippingSuburbAddress = sSuburbAddress || ''
    billingStreetAddress = bStreetAddress || ''
    billingSuburbAddress = bSuburbAddress || ''

    shippingCity = sCity || ''
    billingCity = bCity || ''

    shippingState = sState || ''
    billingState = bState || ''

    shippingPostcode = sPostcode || ''
    billingPostcode = bPostcode || ''

    shippingCountry = sCountry || ''
    billingCountry = bCountry || ''

    shippingTelephone = sTelephone || ''
    billingTelephone = bTelephone || ''

    shippingMethod = sShippingMethod || ''
    paymentMethod = bPaymentMethod || ''
  }

  if (itemShipMethod && itemShipMethod?.length > 0) {
    shippingMethod = itemShipMethod[itemShipMethod.length - 1]
  }

  const shippingInfo = {
    name: shippingName,
    streetAddress: shippingStreetAddress,
    city: shippingCity,
    state: shippingState,
    postCode: shippingPostcode,
    country: shippingCountry,
    telephone: shippingTelephone,
    suburbAddress: shippingSuburbAddress,
  }

  const billingInfo = {
    name: billingName,
    streetAddress: billingStreetAddress,
    city: billingCity,
    state: billingState,
    postCode: billingPostcode,
    country: billingCountry,
    telephone: billingTelephone,
    suburbAddress: billingSuburbAddress,
  }

  return {
    shippingInfo,
    billingInfo,
    shippingMethod,
    merchantId,
    date,
    total,
    paymentMethod,
    subtotal,
    totalShipping,
    totalHandling,
    totalTax,
    shippingProtectionAmount,
    totalWarranty,
    totalProductProtection,
    totalCorePrice,
    items,
  }
}
